import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  //  click events
  click: {
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    mover: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'own-address-radio',
      },
      actionOutcome: '',
    }),
    newBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'billing-new',
      },
      actionOutcome: '',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    oldBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'billing-old',
      },
      actionOutcome: '',
    }),
    otherBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Enter a different address',
      },
      actionOutcome: 'EXPAND',
    }),
    preparer: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'other-address-radio',
      },
      actionOutcome: 'EXPAND',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    recaptchaEpired: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-expired',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});

export const mobileAnalytics = () => ({
  //  outer click events
  click: {
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    newBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'billing-new',
      },
      actionOutcome: '',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    oldBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'billing-old',
      },
      actionOutcome: '',
    }),
    otherBillingType: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Enter a different address',
      },
      actionOutcome: 'EXPAND',
    }),
    recaptchaVerified: () => track('FieldInteracted', {
      webElement: {
        elementType: 'BUTTON',
        text: 'recaptcha-verified',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
  otherBillingModal: {
    closed: () => track('ModalClosed', {
      webElement: {
        name: 'identity-check-different-address-modal',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    continue: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'continue-modal',
      },
      actionOutcome: 'MODAL_CLOSED',
    }),
    opened: () => track('ModalOpened', {
      webElement: {
        name: 'identity-check-different-address-modal',
      },
      actionOutcome: 'MODAL_OPENED',
    }),
    mover: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'own-address-radio',
      },
      actionOutcome: '',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        name: 'continue-modal',
      },
      actionOutcome: '',
    }),
    preparer: () => track('ElementClicked', {
      webElement: {
        text: 'other-address-radio',
      },
      actionOutcome: '',
    }),
  },
});
